import { render, staticRenderFns } from "./BrandSlider.vue?vue&type=template&id=f91b9470&scoped=true&"
import script from "./BrandSlider.vue?vue&type=script&lang=js&"
export * from "./BrandSlider.vue?vue&type=script&lang=js&"
import style0 from "./BrandSlider.vue?vue&type=style&index=0&id=f91b9470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91b9470",
  null
  
)

export default component.exports